import dayjs from "dayjs";

export function calculateAge(birthDate:string) {
    const birthDateObj = dayjs(birthDate);
    const currentDate = dayjs();
    const age = currentDate.diff(birthDateObj, 'year');
  
    if (currentDate.isBefore(birthDateObj.add(age, 'year'), 'year')) {
      return age - 1;
    }
  
    return age;
  }